import React from 'react';
export function Problem() {
  return <section className="bg-gray-50 py-10 md:py-14" data-id="element-76">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-77">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-ink mb-6 leading-tight" data-id="element-78">
          La mayoría ama a sus mascotas, pero las alimenta mal sin saberlo
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed" data-id="element-79">
          Alergias, obesidad, problemas digestivos y falta de energía no son
          normales. Son señales de una alimentación deficiente.
          <br data-id="element-80" />
          <br data-id="element-81" />
          <span className="font-semibold text-ink" data-id="element-82">
            No es falta de amor. Es falta de información correcta.
          </span>
        </p>
      </div>
    </section>;
}